"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combine = combine;
exports.getDiff = getDiff;
var _deepObjectDiff = require("deep-object-diff");
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getDiff(obj1, obj2) {
  var diff = (0, _deepObjectDiff.updatedDiff)(obj1, obj2);
  if ((0, _isEmpty2["default"])(diff)) {
    return null;
  }
  return diff;
}
function combine(obj1, obj2) {
  var diff = getDiff(obj1, obj2);
  var result = (0, _cloneDeep2["default"])(obj1);
  (0, _merge2["default"])(result, diff);
  return result;
}